import { PackageTypeForm } from "@/resources/packages/PackageTypeForm";

export function BetEdit() {
  return (
    <PackageTypeForm action="edit" resource="bets" packageType="bet" label="Bet" />
  );
}

export default BetEdit;
